
import * as constants from './constants';
// import { fromJS } from 'immutable';
import appApi from '@/api/app';
import { $catch } from '@/utils';
import Config from '@/config';
//单独使用
import store from '../';

//路由元数据
export const routerMetaData = (data) => {
    return {
        type: constants.ROUTER_DATA,
        data: data
    };
};
export const routerMetaData_seg = (data) => {
    store.dispatch(routerMetaData(data));
};


//共享加载层状态
export const setLoadingState = (st) => {
    return {
        type: constants.LOADING_STATE,
        data: st
    }
};
export const setLoadingState_seg = (st) => {
    store.dispatch(setLoadingState(st));
};


//获取用户基本信息
export const getUserInfo = () => {
    return (dispatch) => {
        const _data = $catch.getSessionItem(Config.userInfo);
        if(_data){
            dispatch({
                type: constants.USER_INFO_DATA,
                data: _data
            });
        } else {
            //取个人信息
            appApi.getUserInfo()
                .then(res => {
                    if(res){
                        $catch.setSessionItem(Config.userInfo, res);
                        dispatch({
                            type: constants.USER_INFO_DATA,
                            data: (res && res.user) || {}
                        });
                    }
                });
        }

    };
};

//获取用户菜单权限
export const getUserRoute = () => {
    return (dispatch) => {
        const _data = $catch.getSessionItem(Config.userRoute);
        if(_data){
            dispatch({
                type: constants.USER_ROUTE_DATA,
                data: _data
            });
        } else {
            //取个人信息
            appApi.getRouters({
                platType:60
            }).then(res => {
                    if(res){
                        $catch.setSessionItem(Config.userRoute, res);
                        dispatch({
                            type: constants.USER_ROUTE_DATA,
                            data: res  || {}
                        });
                    }
                });
        }

    };
};
